// const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
// const lower = "abcdefghijklmnopqrstuvwxyz"
// const number = "0123456789"
// const special = "!@#$%^&*()_+-=,./<>?;:[]{}|"

// takes a password and returns a message telling you what is wrong with it
// returns blank message if it passes criteria
export function checkPasswordStrength(password) {
  
  let message = ''
  
  if (password.length < 14) {
    message = message + 'must be at least 14 characters; '
  }

  if (!password.match(/[0-9]/)) {
    message = message + 'must contain digits; '
  }

  if (!password.match(/[a-z]/)) {
    message = message + 'must contain lowercase letters; '
  }

  if (!password.match(/[A-Z]/)) {
    message = message + 'must contain uppercase letters; '
  }

  if (!password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)) {
    message = message + 'must contain special characters; '
  }

  return message

}


// WEBPACK FOOTER //
// ./src/_helpers/password-helpers.js